<template>
  <div id="statsTwo"></div>
</template>

<script>
export default {
  name: "StatsTwo",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        number: "147%",
        label: "Revenue Growth",
        subtitle: "Q4 2025 vs Q4 2024",
        chip: "Company Update",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    render() {
      const el = document.getElementById("statsTwo");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const numberSize = exporting ? 200 : 200 * this.scale;
      const labelSize = exporting ? 42 : 42 * this.scale;
      const subtitleSize = exporting ? 26 : 26 * this.scale;
      const logoHeight = exporting ? 40 : 40 * this.scale;
      const chipSize = exporting ? 20 : 20 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.light || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#10a37f";

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background: linear-gradient(135deg, #0f0f0f 0%, #1a1a2e 25%, #16213e 50%, #1a1a2e 75%, #0f0f0f 100%);
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
            position: relative;
            overflow: hidden;
          "
        >
          <!-- Gradient orb effect -->
          <div style="
            position: absolute;
            top: -20%;
            right: -20%;
            width: 60%;
            height: 60%;
            background: radial-gradient(circle, ${primaryColor}25 0%, transparent 70%);
            pointer-events: none;
          "></div>
          <div style="
            position: absolute;
            bottom: -30%;
            left: -20%;
            width: 70%;
            height: 70%;
            background: radial-gradient(circle, #6366f130 0%, transparent 60%);
            pointer-events: none;
          "></div>

          <!-- Header with logo -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" style="opacity: 0.9;" />
          </div>

          <!-- Stats content - centered -->
          <div style="padding: 0 8%; position: relative; z-index: 1; flex: 1; display: flex; flex-direction: column; justify-content: center; align-items: center; text-align: center;">
            <div style="
              font-size: ${numberSize}px;
              font-weight: 700;
              background: linear-gradient(135deg, #ffffff 0%, ${primaryColor} 50%, #6366f1 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
              line-height: 1;
              letter-spacing: -0.03em;
              margin-bottom: 24px;
            ">${this.data.number}</div>

            <div style="
              font-size: ${labelSize}px;
              font-weight: 500;
              color: #ffffff;
              margin-bottom: 12px;
              letter-spacing: -0.01em;
            ">${this.data.label}</div>

            <div style="
              font-size: ${subtitleSize}px;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.6);
            ">${this.data.subtitle}</div>
          </div>

          <!-- Footer with chip -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <div style="display: flex; justify-content: center;">
              <span
                style="
                  display: inline-block;
                  background: rgba(255, 255, 255, 0.1);
                  backdrop-filter: blur(10px);
                  color: #ffffff;
                  font-size: ${chipSize}px;
                  font-weight: 500;
                  border-radius: 999px;
                  padding: 10px 24px;
                  letter-spacing: 0.05em;
                  text-transform: uppercase;
                  border: 1px solid rgba(255, 255, 255, 0.15);
                "
              >
                ${this.data.chip}
              </span>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style scoped></style>
